import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

import UIAlert from "../UIAlert";
import { clx } from "../../../utils/Helpers";
import "./UICallout.scss";

const alertSeverityByVariant = {
  primary: "success",
  success: "success",
  warning: "success",
  error: "failed",
  info: "success",
};

const UICallout = ({
  variant,
  title,
  hasBorder,
  description,
  icon,
  action,
  actionLabel,
  onAction,
  className,
  ...props
}) => {
  const resolvedAction =
    action ||
    (actionLabel && (
      <Button
        type="button"
        variant="text"
        className="ui-callout__action-button"
        onClick={onAction}
      >
        {actionLabel}
      </Button>
    ));

  return (
    <UIAlert
      severity={alertSeverityByVariant[variant]}
      icon={icon === undefined ? false : icon}
      closable={false}
      title={title}
      subTitle={description}
      action={resolvedAction}
      className={clx("ui-callout", 
        `ui-callout--${variant}`, 
        {"ui-callout--not-border": !hasBorder}, 
        className)}
      {...props}
    />
  );
};

UICallout.propTypes = {
  variant: PropTypes.oneOf(["primary", "success", "warning", "error", "info"]),
  title: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.node,
  action: PropTypes.node,
  actionLabel: PropTypes.node,
  onAction: PropTypes.func,
  className: PropTypes.string,
  hasBorder: PropTypes.bool,
};

UICallout.defaultProps = {
  variant: "primary",
  title: null,
  description: null,
  icon: undefined,
  action: null,
  actionLabel: null,
  onAction: undefined,
  className: "",
  hasBorder: true,
};

export default UICallout;
